if (!customElements.get('product-affirmations')) {
  customElements.define(
    'product-affirmations',
    class ProductAffirmations extends HTMLElement {
      constructor() {
        super();
        this.unsubscribe = undefined;
      }

      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.section;
          if (event.data.sectionId !== sectionId) return;

          const newSource = event.data.html.querySelector(
            `#ProductAffirmations-${sectionId}-${this.dataset.blockId}`
          );
          if (newSource) {
            this.innerHTML = newSource.innerHTML;
          }
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
